import {gql} from "@apollo/client";
import {OfflineTestSession} from "../../schema";
import OfflineTestSessionsTable from "../../components/account/offline-test-sessions-table/OfflineTestSessionsTable";

export type QueryData = {
  getOfflineTestSessions: OfflineTestSession[];
};

export const offlineTestSessionsQuery = gql`
  query GetOfflineTestSessionsQuery {
    getOfflineTestSessions {
      ...OfflineTestSessions
    }
  }
  ${OfflineTestSessionsTable.fragments.offlineTestSessions}
`;

export const addOfflineTestSessionMutation = gql`
  mutation AddOfflineTestSessionMutation($data: OfflineTestSessionInput!) {
    offlineTestSession: addOfflineTestSession(data: $data) {
      ...OfflineTestSessions
    }
  }
  ${OfflineTestSessionsTable.fragments.offlineTestSessions}
`;

